import alan from './main';
require ('./echartsChina.js');
(function($) {
    let lastScrollPos = window.pageYOffset;
    window.addEventListener('scroll', function() {
        const currentScrollPos = window.pageYOffset;
        const scrollDirection = currentScrollPos > lastScrollPos ? 'down' : 'up';
        lastScrollPos = currentScrollPos;
        const thresholdHeight = 120; // 设置滚动高度的阈值
        if(currentScrollPos > thresholdHeight && scrollDirection === 'down' && $('.ny-partner-info').length === 0){
            $('.header').addClass('hide');
        }else{
            $('.header').removeClass('hide');
        }
    })
    $.fn.lavaLamp = function(o) {
        o = $.extend({
            fx: "linear",
            speed: 500,
            click: function() {}
        }, o || {});
        return this.each(function() {
            var b = $(this),
                noop = function() {},
                $back = $('<div class="back"><div style="float:left;"></div></div>').appendTo(b),
                $li = $("li", this),
                curr = $("li.on", this)[0] || $($li[0]).addClass("on")[0];
            $li.not(".back").hover(function() {
                move(this)
            }, noop);
            $(this).hover(noop, function() {
                move(curr)
            });
            $li.click(function(e) {
                setCurr(this);
                return o.click.apply(this, [e, this])
            });
            setCurr(curr);

            function setCurr(a) {
                $back.css({
                    "left": a.offsetLeft + "px",
                    "width": a.offsetWidth + "px"
                });
                curr = a
            }

            function move(a) {
                $back.each(function() {
                    $(this).dequeue()
                }).animate({
                    width: a.offsetWidth,
                    left: a.offsetLeft
                }, o.speed, o.fx)
            }
        })
    }
})(jQuery);
$(function(){
  setTimeout(function () {
      new alan.scrollAnimate();
  }, 50)
})